import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 2 }

import { ref, computed } from 'vue'
import Main from '@/layouts/Main.vue'
import Account from '@/layouts/Account.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { useRoute, useRouter } from 'vue-router'
import { isCarRentalModalOpen } from '@/utils/carRentalState'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const layout = computed(() => {
   return route.meta.layout
})

const handleOnlineBooking = () => {
   isCarRentalModalOpen.value = false
   window.open('https://www.booking.com/cars/index.en-gb.html?aid=2327698', '_blank')
}

const handleOfflineBooking = () => {
   isCarRentalModalOpen.value = false
   router.push({ name: 'CarRental', query: { mode: 'offline' } })
}

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    (layout.value == 'web')
      ? (_openBlock(), _createBlock(Main, { key: 0 }, {
          header: _withCtx(() => [
            _createVNode(Header)
          ]),
          content: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          footer: _withCtx(() => [
            _createVNode(Footer)
          ]),
          _: 1
        }))
      : (layout.value == 'account' || (layout.value == 'admin' && (_unref(route).name != 'AdminLogin')))
        ? (_openBlock(), _createBlock(Account, { key: 1 }, {
            content: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ]))
  ], 64))
}
}

})